import type {HelpFile} from '../../types/help'
import {WizardStepScopeTestIds} from '../../../testids/WizardStepScopeTestIds'

export const wizardStepScopeHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [WizardStepScopeTestIds.scopeCard]:
            'Define which assignments this policy certifies — using structured conditions or a CEL expression.',
        [WizardStepScopeTestIds.scopeConditionsLabel]:
            'Structured rule-based scope: field / operator / value rows. Leave empty to certify all active assignments.',
        [WizardStepScopeTestIds.scopeExpressionLabel]:
            'A CEL expression for advanced scope filtering, with field completion.',
        [WizardStepScopeTestIds.previewSection]:
            'Live preview of who will be in scope for the current conditions or expression.',
        [WizardStepScopeTestIds.scopeModeToggle]: null,
        [WizardStepScopeTestIds.btnScopeModeConditions]: null,
        [WizardStepScopeTestIds.btnScopeModeExpression]: null,
        [WizardStepScopeTestIds.expressionEditor]: null,
        [WizardStepScopeTestIds.expressionErrorBanner]: null,
        [WizardStepScopeTestIds.dialogSwitchMode]: null,
    },
}
